import React, {useState} from 'react';
import useQuestionStore from '../store/navigation';
import {
  MultiOption,
  MultiSelectorQuestion,
  QUESTIONIDS,
} from '../types/question';
import QuestionMultiSelector from '../components/MultiSelector';
import {useResultStore} from '../store/responses';

const QuestionTenChargingType: React.FC<MultiSelectorQuestion> = (props) => {
  const {title, multiSelectOptions, nextStepId, subHeading} = props;
  const {setCurrentQuestion, currentQuestion} = useQuestionStore();
  const {result} = useResultStore();
  const resultData = (result[currentQuestion] as Array<string>) || [];
  function handleNextStepBySelectedItems(selectedItems: MultiOption[]) {
    const isEvWallChargerSelected = selectedItems.some(
      (item) => item.value === 'ev_wall_charger',
    );

    if (!isEvWallChargerSelected) {
      setCurrentQuestion(nextStepId);
      return;
    }

    setCurrentQuestion(QUESTIONIDS.questionTwelveTravelDistance);
  }
  const [options, setOptions] = useState(
    [...multiSelectOptions].map((option) => {
      return {isSelect: resultData.includes(option.value), ...option};
    }),
  );

  const handleOptionChange = (selectedValue: string) => {
    setOptions((prevOptions) => {
      const updatedOptions = prevOptions.map((option) => {
        if (selectedValue === 'none') {
          // If 'none' is selected, set isSelected of 'none' to true, and all other options to false
          return {...option, isSelect: option.value === 'none'};
        } else if (option.value === 'none') {
          // If selecting another option, set isSelected of 'none' to false
          return {...option, isSelect: false};
        } else if (option.value === selectedValue) {
          // If selecting another option, set isSelected of that option to the opposite of its current value
          return {...option, isSelect: !option.isSelect};
        } else {
          return option;
        }
      });
      return updatedOptions;
    });
  };

  return (
    <QuestionMultiSelector
      title={title || ''}
      multiSelectOptions={options}
      nextStepId={nextStepId}
      subHeading={subHeading ?? ''}
      handleNextStepBySelectedItems={handleNextStepBySelectedItems}
      maxOptions={options.length - 1}
      handleMultipleOptionChange={handleOptionChange}
      isNoDisabled={true}
    />
  );
};

export default QuestionTenChargingType;
